import type { ModelInfo, RetrievalStep, RetrievedSource, TenantStatus } from './types'

export const mockModel: ModelInfo = {
  name: 'Rager',
  emphasis: 'R−7',
  version: 'v0.7.5',
  contextWindow: 'contexto 32k',
  description:
    'Assistente de pesquisa documental. Responde com base apenas no que está no seu índice vetorial, citando fontes verificáveis em cada afirmação.',
}

export const mockRetrievalSteps: RetrievalStep[] = [
  { id: 'r1', text: 'Pergunta convertida em embedding com o modelo configurado para o tenant.' },
  { id: 'r2', text: 'Busca de similaridade no índice retornou os **4 trechos** mais relevantes.' },
  { id: 'r3', text: 'LLM compôs a resposta usando apenas o contexto recuperado.' },
  { id: 'r4', text: 'Cada afirmação é rastreável até o documento e o chunk de origem.' },
]

export const mockSources: RetrievedSource[] = [
  { id: 'src-uti-2025',            filename: 'protocolo-uti-ped-2025.pdf',        documentId: 'doc_uti_2025',           chunkIndex: 14, page: 7,  score: 0.912 },
  { id: 'src-internacao-2024',     filename: 'protocolo-internacao-2024.pdf',     documentId: 'doc_internacao_2024',    chunkIndex: 9,  page: 5,  score: 0.881 },
  { id: 'src-consentimento-2025',  filename: 'consentimento-modelo-2025.docx',    documentId: 'doc_consentimento_2025', chunkIndex: 2,  page: 1,  score: 0.857 },
  { id: 'src-sbp-2025',            filename: 'diretrizes-sbp-2025.pdf',           documentId: 'doc_sbp_2025',           chunkIndex: 31, page: 22, score: 0.742 },
]

export const mockTenantStatus: TenantStatus = {
  connected: true,
  tenantId: 'clinica-atenas',
}
